module.exports = __webpack_public_path__ + "img/WaitTime.9a20a884.png";